<template>
    <div>
        <div>
            <div class="label">{{ $t('phone') | capitalize }}:</div>
            <div class="value">{{ user.phone }}</div>
            <button
                v-if="!isEditMode"
                @click="onEditClick"
                class="btn btn--md btn--w-144 btn__primary"
            >
                {{ $t('edit') | capitalize }}
            </button>
        </div>
        <GenericForm
            v-show="isEditMode"
            :fields="fields"
            :asyncErrors="asyncErrors"
            @submit="onSave"
        >
            <template slot-scope="slotProps">
                <CustomInput
                    name="phone"
                    v-model="fields.phone.value"
                    label=""
                    :errorMessage="slotProps.errors.phone"
                    @valueChanged="slotProps.onValueChanged"
                    ref="phone"
                />
                <div class="btn__group mb-4">
                    <CustomButton
                        type="submit"
                        :isLoading="isLoading"
                        class="btn btn--md btn--w-90 btn__primary"
                    >
                        {{ $t('save') | capitalize }}
                    </CustomButton>
                    <CustomButton
                        v-if="isEditMode && !isLoading"
                        @click="onCancel"
                        class="btn btn--md btn--w-90 btn__primary"
                    >
                        {{ $t('cancel') | capitalize }}
                    </CustomButton>
                </div>
            </template>
        </GenericForm>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import ValidationError from '@core/errors/network/ValidationError';
    import SmsLimitReachedError from '@core/errors/user/SmsLimitReachedError';
    import UserService from '@core/services/user/UserService';
    import { isRequired } from '@modules/shared/validators/forms';
    import { errorGuard } from '@app/utils';
    import Modals from '@store/modules/ui/shared/modal/modals';

    export default {
        name: 'PhoneUpdateContainer',
        data() {
            return {
                isLoading: false,
                isEditMode: false,
                fields: {
                    phone: {
                        value: null,
                        validate: [
                            isRequired,
                        ]
                    },
                },
                asyncErrors: {},
            };
        },
        created() {
            this.fields.phone.value = this.user.phone;
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        methods: {
            ...mapActions('data/authentication', [
                'setUserData',
            ]),
            ...mapActions('errors', [
                'showError',
            ]),
            ...mapActions('ui/modal', [
                'pushModal'
            ]),
            onEditClick() {
                this.isEditMode = true;
                this.$nextTick(() => {
                    this.$refs.phone.focusInput();
                });
            },
            async onSave() {
                this.isLoading = true;
                await errorGuard({
                    action: async () => {
                        if (this.user.phone === this.fields.phone.value) {
                            this.clearState();
                            return;
                        }
                        try {
                            await UserService.getInstance().updatePhone(this.fields.phone.value);
                        } catch (error) {
                            if (error instanceof SmsLimitReachedError) {
                                this.pushModal({
                                    code: Modals.smsLimitReached.code
                                });
                            } else {
                                throw error;
                            }
                        }
                        this.setUserData({
                            key: 'phone',
                            value: this.fields.phone.value
                        });
                        this.clearState();
                    },
                    onError: (e) => {
                        if (e instanceof ValidationError) {
                            this.asyncErrors = e.fieldErrors;
                        } else {
                            this.showError(e);
                        }
                    },
                });
                this.isLoading = false;
            },
            onCancel() {
                this.clearState();
            },
            clearState() {
                this.isEditMode = false;
                this.fields.phone.value = this.user.phone;
                this.asyncErrors = {};
            }
        },

        components: {}
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/settings/PhoneUpdateContainer.vue